<script lang="ts">
import { useI18n } from "vue-i18n";
import { useChatStore } from "@/store/chat.store";
import PipContainer from "@/components/layout/PipContainer.vue";

export default {
  name: "App",
  components: { PipHost: PipContainer },
  setup() {
    const { t } = useI18n(); // use as global scope
    return { t };
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || "cabinet") + "-layout";
    },
  },
  beforeCreate() {
    const chatStore = useChatStore();

    chatStore.initChat();
  },
};
</script>

<template>
  <component :is="layout">
    <router-view />
  </component>
  <pip-host />
</template>
